export const language = {
    default: 'en',
    autoDetect: 'document',
    translations: {
        'de': {
            consentModal: {
                title: 'Wir schätzen Ihre Privatsphäre',
                description: 'We and our partners use cookies and other technologies to improve your experience, measure performance, and tailor marketing.',
                acceptAllBtn: 'Accept',
                acceptNecessaryBtn: 'Decline',
                showPreferencesBtn: 'Manage preferences',
                footer: '<a href="/en/policies/privacy-policy">Privacy Policy</a>'
            },
            preferencesModal: {
                title: 'Cookie preferences',
                acceptAllBtn: 'Accept all',
                acceptNecessaryBtn: 'Decline all',
                savePreferencesBtn: 'Save my choices',
                closeIconLabel: 'Close modal',
                sections: [
                    {
                        title: 'You control your data',
                        description: 'You can control how your data is used on our website. Learn more below about the cookies we use and choose which cookies work for you. For more information on how we use cookies, please visit our <a href="/policies/privacy-policy">Privacy Policy</a>.',
                    },
                    {
                        title: 'Operate the website',
                        description: 'These cookies are required for the site to function and for necessary activities like protecting against fraud.',

                        //this field will generate a toggle linked to the 'necessary' category
                        linkedCategory: 'necessary'
                    },
                    {
                        title: 'Performance and Analytics',
                        description: 'These cookies help to understand how you interact with the site and what types of content are valuable to you.',
                        linkedCategory: 'analytics'
                    },
                    {
                        title: 'Store your preferences',
                        description: 'These cookies help remember your preferences, like your country or language, to personalize your next visits to the website.',
                        linkedCategory: 'preferences'
                    },
                    {
                        title: 'Personalize marketing',
                        description: 'These cookies are used to provide ads on other sites and marketing communications based on your interests.',
                        linkedCategory: 'marketing'
                    },
                    {
                        title: 'Data Sharing',
                        description: 'This website may engage in the sharing or sale of data, including but not limited to, performance analytics, preferences, and personalized marketing information. By using this site, you consent to the potential sharing or sale of your data for these purposes. Please review our privacy policy for more details on how your data is collected, used, and shared with Service Partners and Regulatory Authorities, public bodies (such as tax authorities, social security institutions, courts), supervisory authorities, or third parties authorized to receive data.',
                        linkedCategory: 'sale_of_data'
                    }
                ]
            }
        },
        'en': {
            consentModal: {
                title: 'We value your privacy',
                description: 'We and our partners use cookies and other technologies to improve your experience, measure performance, and tailor marketing.',
                acceptAllBtn: 'Accept',
                acceptNecessaryBtn: 'Decline',
                showPreferencesBtn: 'Manage preferences',
                footer: '<a href="/policies/privacy-policy">Privacy Policy</a>',
                closeIconLabel: 'Close modal'
            },
            preferencesModal: {
                title: 'Cookie preferences',
                acceptAllBtn: 'Accept all',
                acceptNecessaryBtn: 'Decline all',
                savePreferencesBtn: 'Save my choices',
                closeIconLabel: 'Close modal',
                sections: [
                    {
                        title: 'You control your data',
                        description: 'You can control how your data is used on our website. Learn more below about the cookies we use and choose which cookies work for you. For more information on how we use cookies, please visit our <a href="/policies/privacy-policy">Privacy Policy</a>.',
                    },
                    {
                        title: 'Operate the website',
                        description: 'These cookies are required for the site to function and for necessary activities like protecting against fraud.',

                        //this field will generate a toggle linked to the 'necessary' category
                        linkedCategory: 'necessary'
                    },
                    {
                        title: 'Performance and Analytics',
                        description: 'These cookies help to understand how you interact with the site and what types of content are valuable to you.',
                        linkedCategory: 'analytics'
                    },
                    {
                        title: 'Store your preferences',
                        description: 'These cookies help remember your preferences, like your country or language, to personalize your next visits to the website.',
                        linkedCategory: 'preferences'
                    },
                    {
                        title: 'Personalize marketing',
                        description: 'These cookies are used to provide ads on other sites and marketing communications based on your interests.',
                        linkedCategory: 'marketing'
                    },
                    {
                        title: 'Data Sharing',
                        description: 'This website may engage in the sharing or sale of data, including but not limited to, performance analytics, preferences, and personalized marketing information. By using this site, you consent to the potential sharing or sale of your data for these purposes. Please review our privacy policy for more details on how your data is collected, used, and shared with Service Partners and Regulatory Authorities, public bodies (such as tax authorities, social security institutions, courts), supervisory authorities, or third parties authorized to receive data.',
                        linkedCategory: 'sale_of_data'
                    }
                ]
            }
        },
        'fr': {
            consentModal: {
                title: 'Nous accordons de l\'importance à votre vie privée',
                description: 'Nous et nos partenaires utilisons des cookies et d\'autres technologies pour améliorer votre expérience, mesurer les performances et personnaliser le marketing.',
                acceptAllBtn: 'Accepter',
                acceptNecessaryBtn: 'Refuser',
                showPreferencesBtn: 'Préférences',
                footer: '<a href="/policies/privacy-policy">Politique de confidentialité</a>',
                closeIconLabel: 'Fermer'
            },
            preferencesModal: {
                title: 'Préférences de témoins',
                acceptAllBtn: 'Accepter tout',
                acceptNecessaryBtn: 'Refuser tout',
                savePreferencesBtn: 'Accepter la sélection',
                closeIconLabel: 'Fermer',
                sections: [
                    {
                        title: 'Vous avez le contrôle sur vos données',
                        description: 'Vous pouvez contrôler la manière dont vos données sont utilisées sur notre site web. Apprenez-en davantage ci-dessous sur les cookies que nous utilisons et choisissez ceux qui vous conviennent. Pour plus d\'informations sur l\'utilisation des cookies, veuillez consulter notre <a href="/fr/policies/privacy-policy">Politique de confidentialité</a>.',
                    },
                    {
                        title: 'Témoins strictement nécessaires (Toujours activés)',
                        description: '"Ces cookies sont nécessaires au fonctionnement du site et aux activités essentielles telles que la protection contre la fraude.',

                        //this field will generate a toggle linked to the 'necessary' category
                        linkedCategory: 'necessary'
                    },
                    {
                        title: 'Témoins de performance',
                        description: 'Ces cookies aident à comprendre comment vous interagissez avec le site et quels types de contenu ont de la valeur pour vous.',
                        linkedCategory: 'analytics'
                    },
                    {
                        title: 'Témoins de préférences',
                        description: 'Ces cookies aident à mémoriser vos préférences, telles que votre pays ou votre langue, afin de personnaliser vos prochaines visites sur le site web.',
                        linkedCategory: 'preferences'
                    },
                    {
                        title: 'Témoins de ciblage publicitaire',
                        description: 'Ces cookies sont utilisés pour diffuser des publicités sur d\'autres sites et des communications marketing basées sur vos centres d\'intérêt.',
                        linkedCategory: 'marketing'
                    },
                    {
                        title: 'Témoins de partage des données',
                        description: 'Ce site web pourrait participer au partage ou à la vente de données, y compris, mais sans s\'y limiter, les analyses de performances, les préférences et les informations de marketing personnalisées. En utilisant ce site, vous consentez au partage ou à la vente potentiels de vos données à ces fins. Veuillez consulter notre politique de confidentialité pour plus de détails sur la manière dont vos données sont collectées, utilisées et partagées avec des partenaires de service, des autorités de régulation, des organismes publics (tels que les autorités fiscales, les institutions de sécurité sociale, les tribunaux), des autorités de surveillance ou des tiers autorisés à recevoir des données.',
                        linkedCategory: 'sale_of_data'
                    }
                ]
            }
        }
    }
};
